import React, { useEffect } from "react";
import Container from "../../hoc/Container";
import { tgIcon } from "../../../images";
import SteamTopUpWidget from "../../components/steam/SteamTopUpWidget";

function SteamPageNew() {
  useEffect(() => {
    window.ym(93997310, "hit", "/steam-new", {
      params: {
        title: "Steam",
        referer: "https://trendy-eng-shop.ru/",
      },
    });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <Container>
      <section className="content-block mb-2">
        <h1 className="head-1">Пополнение Steam</h1>
        
        <div className="mb-8 flex flex-col md:flex-row items-start justify-between space-x-2 px-2">
          {/* Виджет пополнения Steam - всегда первый на мобилке, справа на десктопе */}
          <div className="w-full md:basis-3/5 flex flex-col items-center justify-center order-1 md:order-2">
            
            {/* Виджет пополнения Steam */}
            <div className="my-2 w-full steam-widget">
              <SteamTopUpWidget />
            </div>
            
            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                Или купите карты через Telegram
              </p>
              <div
                onClick={() => window.ym(93997310, "reachGoal", "tgClickSteam")}
              >
                <a
                  href={"https://t.me/trendy_steam_bot?start=ref-001"}
                  className="flex w-40 mx-auto justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  target="_blank"
                  rel="noreferrer"
                >
                  Купить в <img src={tgIcon} alt="TG" className=" ml-2" />
                </a>
              </div>
            </div>
            {/* <ConvertCourse courseNow={0.017594} /> */}
          </div>
          
          {/* Картинка - всегда внизу на мобилке, слева на десктопе */}
          <div className="w-full md:basis-2/5 flex justify-center items-start order-2 md:order-1 mt-4 md:mt-0">
            <div className="w-full max-w-md md:max-w-none flex justify-center items-start pt-4">
               <img
                 className="w-full h-auto rounded-lg hover:shadow-lg hover:shadow-zinc-900 transition-shadow duration-300 cursor-pointer"
                 src="/static/images/steampop.png"
                 alt="Steam Trendy Shop Telegram"
                 onClick={() => {
                   // Прокручиваем к виджету пополнения
                   const widget = document.querySelector('.steam-widget');
                   if (widget) {
                     widget.scrollIntoView({ 
                       behavior: 'smooth', 
                       block: 'center' 
                     });
                   }
                   // Отправляем метрику
                   window.ym(93997310, "reachGoal", "steampopClickToWidget");
                 }}
               />
            </div>
          </div>
        </div>
      </section>
      <article className="content-block text-justify">
        <section className=" my-5 ">
          <h3 className="my-2 text-center text-2xl overline decoration-sky-500">
            Описание
          </h3>
          <p className=" dark-text my-3 w-full indent-4 text-gray-700">
            С помощью данного сервиса можно пополнять аккауты Russia, Belarus, Ukraine, Armenia, Azerbaijan, Georgia, Kazakhstan, Kyrgyzstan, Moldova, Tajikistan, Turkmenistan and Uzbekistan. Выбор региона просто для удобства показывает примерный курс, но на реальное пополнение нужного вам региона не влияет, *курс может отличаться от пришедшей суммы в Steam вплоть до 3% как в меньшую, так и в большую сторону.
          </p>
          <p className=" dark-text my-3 w-full text-sm text-gray-500 dark:text-gray-400">
            * - примерный курс, может отличаться от фактического пополнения в Steam<br/>
            ** - может отличаться от курса ЦБ РФ
          </p>
        </section>
        <section id="how-to-find-login" className="my-8">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700 rounded-lg p-6 shadow-lg">
            <h3 className="text-center text-2xl font-bold text-gray-800 dark:text-white mb-6">
              Как найти свой логин
            </h3>
            
            <div className="flex flex-col lg:flex-row items-center gap-6">
              {/* Изображение */}
              <div className="flex-shrink-0">
                <img 
                  src="/static/images/steam-login.png" 
                  alt="Steam логин инструкция"
                  className="w-full max-w-2xl h-auto rounded-lg shadow-xl"
                />
              </div>
              
              {/* Текст */}
              <div className="flex-1 max-w-sm">
                <div className="bg-white dark:bg-gray-600 rounded-lg p-4 shadow-sm">
                  <p className="text-gray-700 dark:text-gray-200 text-sm leading-relaxed mb-3">
                    <strong>Логин</strong> - это то, что вы вводите для входа в Steam. 
                    Перепроверить можно так:
                  </p>
                  <ol className="text-gray-700 dark:text-gray-200 space-y-2">
                    <li className="flex items-start">
                      <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-0.5">1</span>
                      <span className="text-xs">Сверху справа <strong>Ваш ник</strong></span>
                    </li>
                    <li className="flex items-start">
                      <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-0.5">2</span>
                      <span className="text-xs">Нажимаем</span>
                    </li>
                    <li className="flex items-start">
                      <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-0.5">3</span>
                      <span className="text-xs"><strong>Об аккаунте:</strong> ВАШ ЛОГИН</span>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm text-gray-500 dark:text-gray-400 text-center">
            *** - Нажимая «Подтвердить», вы соглашались пополнить аккаунт Steam именно с этим логином и понимаете, что после оплаты эту операцию невозможно будет отменить
          </p>
        </section>
        <section className=" my-5">
          <h3 className="my-2 text-center text-2xl">
            Особенности:
          </h3>
          <p className=" dark-text my-3 w-full indent-4 text-gray-700">
            Пополение обычное занимает меньше 10 минут, но если аккаунт не пополнился в течение 2 часов, то пишите в <a href={process.env.REACT_APP_SUPPORT_URL} className="text-blue-700 dark:text-indigo-400" target="_blank" rel="noreferrer">техподдержку</a>.
          </p>
        </section>
        
        <section className=" my-5">
          <p className=" dark-text my-3 w-full indent-4 text-gray-700">
            Это не коды пополнения. Теперь вы можете легко пополнить свой Steam аккаунт прямо на сайте! 
            Просто введите логин Steam, выберите сумму пополнения и регион. 
            Система автоматически конвертирует валюту и покажет стоимость в рублях, 
            тенге или гривнах. Также вы можете купить подарочные карты Steam через 
            нашего <a href="https://t.me/trendy_steam_bot?start=ref-001" className="text-blue-700 dark:text-indigo-400" target="_blank" rel="noreferrer">Telegram бота</a> для подарков друзьям.
          </p>
        </section>
      </article>
    </Container>
  );
}

export default SteamPageNew;
